import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ExperienceBody from "./experienceBody";

function Experience(){
    return(
       
    <div className="Academics" style={{backgroundColor: "black"}}>
       <Navbar/>
<ExperienceBody/>
<Footer/>

        </div>

    )
}
export default Experience;